import { calculateJWTTokenExpirationDate, createAuthReducer } from '@tshio/redux-api-auth-middleware';

export const authReducer = createAuthReducer({
  getExpirationTimestamp: (payload) => calculateJWTTokenExpirationDate(payload) - 60,
});
